<div class="details-div">
  <!--<h4>Kawneer {{lieratureDetails?.docGroupingAlias}}</h4>
  <p>{{pagelabels.noteLblfirst}}</p>
  <p>{{pagelabels.noteLblsecond}}</p>-->
  <h4>{{documentTxt.headingLbl?documentTxt.headingLbl:pagelabels.headingLbl}} {{lieratureDetails?.docGroupingAlias}}</h4>
  <!--<p>{{documentTxt.note1Lbl?documentTxt.note1Lbl:pagelabels.note1Lbl}}</p>-->
<!--  <p>{{documentTxt.note2Lbl?documentTxt.note2Lbl:pagelabels.note2Lbl}}</p>-->
  <div>
    <!-- angular 13 upgrade <kendo-textbox-container class="p-0 mt-4 mb-4 col-xs-12 col-sm-6 col-md-6 col-lg-6">
    <input kendoTextBox
           type="search" placeholder="Search"
           (input)="onSearchChangeFilter($event.target.value)" />
  </kendo-textbox-container>-->
    <kendo-formfield class="p-0 mt-4 mb-4 col-xs-12 col-sm-6 col-md-6 col-lg-6">
      <input kendoTextBox
             type="search" placeholder="Search"
             (input)="onSearchChangeFilter($event.target.value)" class="widthfixed"/>
    </kendo-formfield>
    <br />
  </div>
  <kendo-panelbar #panelbar>
    <kendo-panelbar-item title="{{list.docCategoryDesc}}"
                         [expanded]="false" *ngFor="let list of filteredCollection">
      <ng-template kendoPanelBarContent>
        <table class="table table-bordered table-hover">
          <tbody class="tbodyCls">
            <div class="display-row-items" *ngFor="let child of list.pdfCollection">
            <tr *ngIf="child.docSubCategoryDesc">
              <td colspan="4" style="text-align: left;">
                <h6 style="text-align:left" class="sub-heading" *ngIf="child.docSubCategoryDesc" [innerHTML]="child.docSubCategoryDesc"></h6>
              </td>
            </tr>
            <tr>
              <td style="width:20px">
                <span *ngIf="child.pathName && ![151,148,144,142,140].includes(child.docSubCategoryID)">
                  <button kendoButton [icon]="'download'" [disabled]="downloadingMap[child.docID]" (click)="onClickDownload(child)" class="m-2 btn btn-success btnSizeCls"></button>
                </span>
              </td>
              <td class="word-break-pwa" *ngIf="[151,148,144,142,140].includes(child.docSubCategoryID)">
                <span class="k-icon"
                      [ngClass]="child.pathName?.toLowerCase().endsWith('.html') ? 'k-i-youtube' : 'k-i-file-pdf'">
                </span>
                <a href="{{imageUrl}}{{child.pathName}}" target="_blank" [innerHTML]="child.docDesc"></a>
              </td>
              <td style="text-align:left; vertical-align:middle" *ngIf="child.docDesc" class="text-align-class word-break-pwa" [innerHTML]="child.docDesc"></td>
              <td style="vertical-align:middle" *ngIf="lieratureDetails?.isSecondColumnVisible===true" class="text-align-class word-break-pwa" [innerHTML]="child.partNo"></td>
              <td style="vertical-align:middle" *ngIf="lieratureDetails?.isThirdColumnVisible===true" class="text-align-class word-break-pwa" [innerHTML]="child.revision"></td>
            </tr>
</div>
        </tbody>
       </table>
    </ng-template>
    </kendo-panelbar-item>

  </kendo-panelbar>


<br />
<div *ngIf="hasAccessToAdmin">
  <kendo-panelbar #panelbar>
    <kendo-panelbar-item title="{{list.docCategoryDesc}}"
                         [expanded]="false" *ngFor="let list of filteredCollectionAdmin">
      <ng-template kendoPanelBarContent>
        <table class="table table-bordered table-hover">
          <tbody class="tbodyCls">
            <div class="display-row-items" *ngFor="let child of list.pdfCollection">
              <!--  <div class="display-row-items" *ngFor="let subList of list.literatureDocumentSubCategory"> -->
              <!--<h6 class="sub-heading" *ngIf="child.docSubCategoryDesc" [innerHTML]="child.docSubCategoryDesc"></h6>-->
            <tr *ngIf="child.docSubCategoryDesc">
              <td colspan="4" style="text-align: left;">
                <h6 style="text-align:left" class="sub-heading" *ngIf="child.docSubCategoryDesc" [innerHTML]="child.docSubCategoryDesc"></h6>
              </td>
            </tr>
            <tr>
              <td style="width:20px">
                <span *ngIf="child.pathName">
                  <button kendoButton [icon]="'download'" (click)="onClickDownload(child)" class="m-2 btn btn-success btnSizeCls"></button>
                </span>
              </td>
              <!--<td class="word-break-pwa"><span class="k-icon k-i-file-pdf" *ngIf="child.docDesc"></span><a href="{{imageUrl}}{{child.pathName}}" target="_blank" [innerHTML]="child.docDesc"></a></td>-->
              <td style="text-align:left; vertical-align:middle" *ngIf="child.docDesc" class="text-align-class word-break-pwa" [innerHTML]="child.docDesc"></td>
              <td style="vertical-align:middle" *ngIf="lieratureDetails?.isSecondColumnVisible===true" class="text-align-class word-break-pwa" [innerHTML]="child.partNo"></td>
              <td style="vertical-align:middle" *ngIf="lieratureDetails?.isThirdColumnVisible===true" class="text-align-class word-break-pwa" [innerHTML]="child.revision"></td>
              <td style="vertical-align:middle" *ngIf="hasAccessToAdmin" class="text-align-class word-break-pwa">
                <button (click)="approve(child)">Approve</button>
              </td>
            </tr>
</div>

<!--</div>-->
      </tbody>
      </table>
    </ng-template>
  </kendo-panelbar-item>
</kendo-panelbar>
</div>
<!--</div>-->
